import { useTranslation } from 'react-i18next';
import { Button } from '@/ui/Button/Button';
import { useKiosk } from './KioskProvider';
import styles from './KioskOverlay.module.css';

/**
 * Schermata di attesa del totem ("attract loop") + barra di uscita.
 *
 * Accessibilità:
 *  · l'invito è un `<button>` a tutto schermo, non un `<div onClick>`: si
 *    attiva anche con Enter/Spazio da una tastiera collegata al totem;
 *  · l'animazione di richiamo si spegne con `prefers-reduced-motion` e col
 *    toggle "riduci animazioni" (WCAG 2.3.3);
 *  · la barra di uscita ha bottoni etichettati, non solo icone.
 */
export function KioskOverlay() {
  const { t } = useTranslation();
  const { enabled, attractVisible, dismissAttract, exitKiosk, enterKiosk } = useKiosk();

  if (!enabled) return null;

  return (
    <>
      <div className={styles.exitBar}>
        <Button
          variant="ghost"
          size="small"
          /* `enterKiosk` chiede il fullscreen: DEVE partire da questo click,
             non da un effetto, o il browser lo rifiuta. */
          onClick={() => void enterKiosk()}
        >
          {t('totem_fullscreen', 'Schermo intero')}
        </Button>
        <Button variant="ghost" size="small" onClick={() => void exitKiosk()}>
          {t('totem_exit', 'Esci dalla modalità totem')}
        </Button>
      </div>

      {attractVisible ? (
        <button
          type="button"
          className={styles.overlay}
          onClick={dismissAttract}
          /* Il nome accessibile completo sta in aria-label: il contenuto
             visivo è su due righe e sarebbe letto a pezzi. */
          aria-label={`${t('totem_welcome', 'Benvenuti in Puglia')}. ${t(
            'totem_touch_to_start',
            'Tocca per iniziare',
          )}`}
        >
          <span>
            <span className={styles.title} aria-hidden="true">
              {t('totem_welcome', 'Benvenuti in Puglia')}
            </span>
            <span className={styles.hint} aria-hidden="true">
              {t('totem_touch_to_start', 'Tocca per iniziare')}
            </span>
            <span className={styles.pulse} aria-hidden="true" />
          </span>
        </button>
      ) : null}
    </>
  );
}
